// We need jQuery
var $ = window.jQuery;

export default function(){
  $('select').select2({
    width: '100%'
  });
}
